// extracted by mini-css-extract-plugin
export default {"wrapper":"SmallSpinner_wrapper__-PTlp","spinner":"SmallSpinner_spinner__Ef3e8"};